import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CanvasElementComponent } from '../../canvas-elements/element-component';
import { CanvasElementBaseNavigationComponent } from '../__base/base-navigation.component';

@Component({
  selector: 'be-nav-bottombar',
  templateUrl: './nav-bottombar.component.html',
  styleUrls: ['./nav-bottombar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavBottombarComponent
  extends CanvasElementBaseNavigationComponent<'navBottombar'>
  implements CanvasElementComponent<'navBottombar'> {}
